module.exports = __webpack_public_path__ + "media/images/emblems/Therwil-blason-4c35fe63cfa34f21a3fcda3fdac046fd.svg";